<script>
  import options from './FormStepZero.options'
  export default options
</script>

<template>
  <article class="kb-form-step-zero">
    
      <article class="kb-single-content-spot kb-single-content-spot--no-icon">
        <div class="kb-single-content-spot__decoration"></div>

        <div class="kb-single-content-spot__content">
          <h2 class="kb-single-content-spot__title">
            {{ getLabel('errorTitle') }}
          </h2>
          <p class="kb-single-content-spot__text-content">
            {{ getLabel('errorMessage') }}
          </p>
        </div>
        <div class="kb-single-content-spot__button-wrapper">
          <div>
            <a :href="getLabel('returnButtonUrl')">
              <button class="kb-button kb-button--full-color-spot">
                {{ getLabel('returnButtonText') }}
              </button>
            </a>
          </div>
        </div>
      </article>

  </article>
</template>
